module.exports = __webpack_public_path__ + "static/media/pic3.e50fe39a.jpg";